import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import './MobileHeader.css';

const MobileHeader: React.FC = () => {
  const navigate = useNavigate();
  const { totalItems } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItems = [
    { path: '/', label: 'Home' },
    { path: '/shop', label: 'Shop' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/about', label: 'About' },
    { path: '/orders', label: 'Orders' },
    { path: '/profile', label: 'Profile' },
    { path: '/contact', label: 'Contact' },
    { path: '/contact?type=engraving', label: 'Engraving' },
  ];

  return (
    <header className="mobile-header">
      <div className="mobile-header-content">
        {/* Logo */}
        <div className="mobile-header-logo" onClick={() => navigate('/')}>
          <img 
            src="/Untitled design (24).png" 
            alt="Quirke Trophies" 
            className="mobile-header-logo-image"
          />
          <div className="mobile-header-logo-text">
            <span className="mobile-header-logo-title">Quirke</span>
            <span className="mobile-header-logo-subtitle">TROPHIES</span>
          </div>
        </div>

        {/* Right buttons: Cart and Menu */}
        <div className="mobile-header-actions">
          {/* Cart Button */}
          <button 
            className="mobile-header-cart-button"
            onClick={() => navigate('/cart')}
            aria-label="Cart"
          >
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
            {totalItems > 0 && (
              <span className="mobile-header-cart-badge">{totalItems > 99 ? '99+' : totalItems}</span>
            )}
          </button>

          {/* Menu Button */}
          <button 
            className="mobile-header-menu-button"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              {menuOpen ? (
                <path d="M18 6L6 18M6 6l12 12" />
              ) : (
                <path d="M3 12h18M3 6h18M3 18h18" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {menuOpen && (
        <div className="mobile-header-menu">
          {menuItems.map((item) => (
            <button
              key={item.path}
              className="mobile-header-menu-item"
              onClick={() => {
                navigate(item.path);
                setMenuOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default MobileHeader;

